import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { FaQuoteRight, FaCircle, FaRegCircle } from 'react-icons/fa';

import styled from 'styled-components'

import { reviews } from '../utils/constants';

const Reviews = () =>  {
  const [people, setPeople] =useState(reviews);
  const [index, setIndex] =useState(0);

  useEffect(() =>{
    const lastIndex = people.length -1;
    if(index < 0){
      setIndex(lastIndex)
    }
    if(index > lastIndex) {
      setIndex(0)
    }
  }, [index,people]);

  useEffect(() =>{
  let slider =  setInterval(() => {
      setIndex(index + 1);
    }, 6000);
    return () => clearInterval(slider) //a new index creates another timer. This line clears out existing timer.
  }, [index]);

  return (
    <SliderContainer>
      <h2>
        What do our students say
      </h2>

          <div className='section-center'>
            {people.map((person,personIndex) =>{
              const { id, image, name, title, quote } = person;

              let position = 'nextSlide';
              if(personIndex === index) {
                position = 'activeSlide';
              }
              if(personIndex === index -1 ||
                (index ===0 && personIndex === people.length -1 )
              ){
                position = 'lastSlide';
              }
              return (
                <article className={position} key={id}>

                  <div>
                  <img src={image} alt={name} className="person-img" />

                  </div>

                </article>
              );
            })}
            <button
              type="button"
              className='prev'
              onClick={()=> setIndex(index -1)}
              aria-label="Previous review"
            >
              <FiChevronLeft />
            </button>
            <button
              type="button"
              className='next'
              onClick={()=> setIndex(index +1)}
              aria-label="Next review"
            >
              <FiChevronRight />
            </button>
            <div className='breadcrumbs'>

            </div>
          </div>
    </SliderContainer>
    )
}
const SliderContainer = styled.div`
  background-color: var(--clr-bcgrey);
  margin-top: 0px;
  padding-top: 2rem;
  padding-bottom: 1rem;

  h2 {
    text-align: center;
    color: var(--clr-primary-1);
    text-transform: uppercase;

  }
  .title span {
    font-size: 0.85em;
    color: var(--clr-primary-5);
    margin-right: 1rem;
    font-weight: 700;
  }
  .section-center {
    margin: 0 auto;
    /* margin-top: 4rem; */

    /* have to have a height */
    height: 450px;
    max-width: 800px;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .person-img {
     border-radius: 8px;
    /* margin-bottom: 1rem; */
    width: 360px;
    object-fit: cover;

  }
  article h4 {
    text-transform: uppercase;
    color: var(--clr-primary-5);
    margin-bottom: 0.25rem;
  }
  .title {
    text-transform: capitalize;
    margin-bottom: 0.75rem;
    color: var(--clr-grey-3);
  }
  .text {
    max-width: 35em;
    margin: 0 auto;
    margin-top: 2rem;
    line-height: 2;
    color: var(--clr-grey-5);
  }
  .icon {
    font-size: 3rem;
    margin-top: 1rem;
    color: var(--clr-primary-5);
  }
  .breadcrumbs {
  position: absolute;
  top: 380px;
  width: 100%;
  display: flex;
  justify-content: center;
  }
  .prev,
  .next {
    position: absolute;
    bottom: 1rem;
    z-index: 2;
    background: rgba(102, 36, 78, 0.95);
    color: var(--clr-white);
    width: 3.25rem;
    height: 3.25rem;
    display: grid;
    place-items: center;
    border: 2px solid rgba(255, 255, 255, 0.8);
    font-size: 1.55rem;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.18);
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  }

  .prev {
  left: calc(50% - 4.25rem);
}

.next {
  right: calc(50% - 4.25rem);
}

  .prev:hover,
  .next:hover {
    background: var(--clr-primary-1);
    border-color: var(--clr-primary-2);
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.24);
    transform: translateY(-2px);
  }

  .prev:focus-visible,
  .next:focus-visible {
    outline: 3px solid var(--clr-primary-2);
    outline-offset: 3px;
  }

  .prev svg,
  .next svg {
    stroke-width: 3;
  }

  @media (min-width: 992px) {

    h2 {
      text-align: left;
      margin-left: 4rem;
    }
    .text {
      max-width: 45em;
    }
    .prev,
    .next {
      width: 3.5rem;
      height: 3.5rem;
      font-size: 1.75rem;
      position: absolute;
      top: 200px;
      transform: translateY(-50%);
    }
    .prev {
      left: 1rem;
    }
    .next {
      right: 1rem;
    }
    .prev:hover,
    .next:hover {
      transform: translateY(-50%) scale(1.04);
    }
    .breadcrumbs {
      top: 220px;
    }
    .person-img {
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      width: 420px;
    }
  }

  article {
    position: absolute;
    flex: 1;
    display: flex;
    flex-direction: column;
    top: 1rem;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: var(--transition);
  }
  article.activeSlide {
    opacity: 1;
    transform: translateX(0);
  }
  article.lastSlide {
    transform: translateX(-100%);
  }
  article.nextSlide {
    transform: translateX(100%);
  }

  /* @media only screen and (max-width: 600px) {
    article {
      position: absolute;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  } */

`

export default Reviews;
